//      
import React from 'react';
import { Link } from 'react-router-dom';

// return a link or a span
              
                       
               
                  
                   
  

const ConditionalLink = ({ condition, to, children, ...domProps }       ) => {
    if (!condition) {
        return <span {...domProps}>{children}</span>;
    }
    return (
        <Link to={to} {...domProps}>
            {children}
        </Link>
    );
};

export default ConditionalLink;
